"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagInfo = void 0;
class TagInfo {
    constructor(name, slug, questions, frequencies) {
        this.name = name;
        this.slug = slug;
        this.questions = questions;
        this.frequencies = frequencies;
        this.initFrequency(frequencies, questions);
    }
    initFrequency(frequencies, questions) {
        try {
            const freqs = JSON.parse(frequencies);
            for (let questionId in freqs) {
                if (questions) {
                    questions.forEach((question) => {
                        if (question.questionId === questionId) {
                            question.frequency = freqs[questionId];
                        }
                    });
                }
            }
        }
        catch (e) {
            console.error(e);
        }
    }
}
exports.TagInfo = TagInfo;
